import { BoardCustomerService } from "../../components/CustomerService";

export const CustomerService = () => {
    return <BoardCustomerService/>;
};